/*
 * Copyright (c) 2022. Revo Digital 
 * ---
 * Author: gabriele
 * File: TextAreaControlInput.tsx
 * Project: mle-client-n 
 * Committed last: 2022/1/20 @ 1623
 * ---
 * Description:
 */


import { ChildControlFieldProps }                  from './ShapeControlView';
import { observer }                                from 'mobx-react';
import { ShapeControlWrapper }                     from './ShapeControlWrapper';
import { Button, Intent, TextArea }                from '@blueprintjs/core';
import React, { useCallback, useEffect, useState } from 'react';

export const TextAreaControlInput = observer((props: ChildControlFieldProps<string>) => {
  const [content, setContent] = useState('');
  const [changed, setHasChanged] = useState(false);

  useEffect(() => {
    setContent(props.observableValue);
  }, [props.observableValue]);

  const handleTextUpdate = useCallback((event) => {
    setContent(event.target.value);
    setHasChanged(true);
  }, [setContent, setHasChanged]);

  const handleConfirm = useCallback(() => {
    props.setter(content);
    setHasChanged(false);
  }, [setHasChanged, content]);

  const handleKeyDown = useCallback((event: React.KeyboardEvent<any>) => {
    if(event.ctrlKey && event.key === "Enter") handleConfirm();
  }, [handleConfirm]);

  return (
    <ShapeControlWrapper label={ props.label } labelInfo={ props.labelInfo }>
      <div className={ 'flex flex-col' }>
        <div>
          <TextArea large intent={ Intent.PRIMARY }
                    value={ content } onChange={ handleTextUpdate }
                    className={ 'h-36' } onKeyDown={ handleKeyDown }/>
        </div>
        <div className={ 'my-2' }>
          { changed && <Button onClick={ handleConfirm }
                               intent={ Intent.PRIMARY }>Applica</Button>
          }</div>
      </div>
    </ShapeControlWrapper>
  );
});